// extracted by mini-css-extract-plugin
export default {"root":"link_root__+nxpw","color-primary":"link_color-primary__Qchbz","color-text-secondary":"link_color-text-secondary__zp+cK","size-small":"link_size-small__0pKqs"};